/* globals ga */
'use strict';

import $ from 'jquery';
import { addClearDateButton } from '@/js/modules/jquery_datepicker_clear_button';
import '@/js/modules/jquery_modal_defaults';
import '@/js/modules/jquery_datepicker_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function scrollToProjectFormFirstError() {
    // The error just shown can sit in a section that is hidden on the current step.
    const $firstError = $('.form-error:visible:first');
    if (!$firstError.length) {
      return;
    }

    $('body,html').animate(
      {
        scrollTop: $firstError.position().top - 120,
      },
      800
    );
  }

  function checkAllRequiredQuestions() {
    const allRequiredSteps = $('.form-error--project-form-required').map((_i, el) => {
      return $(el).data('step');
    });
    let checkRequiredSteps = true;
    allRequiredSteps
      .toArray()
      .forEach(
        (step, _i) => (checkRequiredSteps = checkRequiredSteps && checkRequiredQuestion(step))
      );
    return checkRequiredSteps;
  }

  function checkRequiredQuestion(currentStep) {
    if (
      $('.selection-list--measurements').length > 0 &&
      $('.selection-list--measurements').hasClass('hide')
    ) {
      // measurements question is required
      $('#show_measurements_now').prop(
        'checked',
        $('.selection-list--measurements').closest('.project-form-section').find('.uploader__thumb')
          .length > 0
      );
    }

    const $requiredErrorMessage = $(`.form-error--project-form-required[data-step=${currentStep}]`);
    $requiredErrorMessage.hide();

    if ($requiredErrorMessage.length > 0) {
      const section = $requiredErrorMessage.closest('.project-form-section');
      if (section.find('input[type=checkbox]').length > 0) {
        if (section.find('input[type=checkbox]:checked').length === 0) {
          $requiredErrorMessage.show();
          return false;
        }
      } else if (section.find('input[type=radio]').length > 0) {
        if (section.find('input[type=radio]:checked').length === 0) {
          $requiredErrorMessage.show();
          return false;
        }
      } else if (section.find('.field').length > 0) {
        let answered = false;
        section.find('.field').each((_i, el) => {
          answered = answered || $(el).val().trim().length > 0;
        });
        if (!answered) {
          $requiredErrorMessage.show();
          return false;
        }
      } else if (section.find('.textarea').length > 0) {
        let answered = false;
        section.find('.textarea').each((_i, el) => {
          answered = answered || $(el).val().trim().length > 0;
        });
        if (!answered) {
          $requiredErrorMessage.show();
          return false;
        }
      } else if (section.find('.uploader--custom-question').length) {
        if (!section.find('.uploader--custom-question').find('.uploader__thumb').length) {
          $requiredErrorMessage.show();
          return false;
        }
      }
    }

    return true;
  }

  $(function () {
    if ($('body').is('#projects-form, #projects-preview')) {
      $(document).on('click', '.header__logo', () => {
        return false;
      });

      $('.header__logo').css('cursor', 'default');

      // scroll to next step after checking radio button
      $(document).on('change', 'input[type="radio"].selection-list__input:checked', (e) => {
        const currentStep = $(e.target).closest('.selection-list').data('scroll-step');
        const $nextStep = $(`[data-scroll-step="${currentStep + 1}"]`);

        if (
          // skip on timeline-custom, budget-custom, show_measurements_now, show_inspiration_now
          $(e.target).is(
            '#timelines-custom, #budget-custom, #show_measurements_now, #show_inspiration_now'
          ) ||
          // skip if there are no more steps
          !$nextStep.length
        ) {
          return false;
        }

        // A required question's error message or a custom question's hidden fields can sit between
        // the header and the step, and on some questions the step is the header itself.
        const $step = $nextStep.first();
        const $nextHeader = $step.is('.project-form-section__header')
          ? $step
          : $step.prevAll('.project-form-section__header').first();
        if (!$nextHeader.length) {
          return false;
        }

        let topOffset;
        if ($nextStep.prev('.project-form-section__divider').length) {
          // scrolling between section
          topOffset = $nextHeader.css('margin-top');
          topOffset =
            parseInt(topOffset) +
            parseInt($('.project-form-section').css('margin-top')) +
            $('.project-form-section__divider').height();
        } else {
          // scrolling inside section
          topOffset = $nextHeader.css('margin-top');
        }

        setTimeout(() => {
          const { top } = $nextHeader.position();
          window.scrollTo({ top: top - parseInt(topOffset), behavior: 'smooth' });
        }, 100);
      });

      // add ability to un-select radio buttons
      $(document).on(
        'click',
        '.selection-list__input[type=radio]:checked + .selection-list__label',
        (e) => {
          const $label = $(e.currentTarget);

          // skip this logic for custom-budget, show-measurements, show-inspiration and specific-date radios,
          // these should not be un-selected
          if (
            $label.is('.selection-list__label--custom-budget') ||
            $label.is('.selection-list__label--specific-date') ||
            $label.prop('for') === 'show_measurements_now' ||
            $label.prop('for') === 'show_measurements_later' ||
            $label.prop('for') === 'show_inspiration_now' ||
            $label.prop('for') === 'show_inspiration_later'
          ) {
            return true;
          }

          const $radio = $label.prev();
          $radio.prop('checked', false).change();

          return false;
        }
      );

      $(document).on('change', 'input[name="project[how_finished]"]', (e) => {
        if ($(e.target).val() === 'Starting from scratch') {
          $('.project-form-section__existing-furniture').addClass(
            'project-form-section__existing-furniture--hidden'
          );
        } else {
          $('.project-form-section__existing-furniture').removeClass(
            'project-form-section__existing-furniture--hidden'
          );
        }
      });

      $(document).on('change', '.selection-list__input--budget', (e) => {
        $('.selection-list__show-custom-fields').css('display', 'flex');
        $('.custom-budget-fields').hide();

        let budgetFrom = 0;
        let budgetTo = 0;
        const $radio = $(e.target);

        if ($radio.prop('checked') === true) {
          [budgetFrom, budgetTo] = $radio.val().split('-');
        }

        $('#project_budget_from').val(budgetFrom);
        $('#project_budget_to').val(budgetTo);
      });

      $(document).on('click', '.selection-list__show-custom-fields', () => {
        $('.selection-list__show-custom-fields').hide();
        $('.custom-budget-fields').show();
        $('input[name="project[budget_to]"]').val('');
        $('input[name="project[budget_from]"]').val('').focus();
      });

      $(document).on('change', '.selection-list__input--timeline', () => {
        $('.selection-list__specific-date').hide();
        $('.selection-list__show-specific-date').css('display', 'flex');
      });

      $('.field--specific-project-date').datepicker({
        dateFormat: 'yy-mm-dd',
        beforeShow(input, calendar) {
          addClearDateButton(input);

          // required to calculate calendar position properly
          setTimeout(() => {
            calendar.dpDiv.css({
              top: `${$(input).offset().top + 40}px`,
            });
          }, 10);
        },
        onChangeMonthYear: (_year, _month, calendar) => {
          addClearDateButton(calendar.input[0]);
        },
        onSelect: (e) => {
          $('body,html').animate(
            {
              scrollTop:
                $('.selection-list--timelines')
                  .closest('.project-form-section')
                  .next('.project-form-section')
                  .position().top - 50,
            },
            800
          );
        },
      });

      $(document).on('click', '.selection-list__show-specific-date', () => {
        $('.selection-list__specific-date').css('display', 'flex');
        $('.selection-list__show-specific-date').hide();
        $('.field--specific-project-date').val('').focus();
      });

      $(document).on('change', '.field--specific-project-date', (e) => {
        $('input[name="project[timelines]"]').val($(e.target).val());
      });

      $(document).on('change', 'input[name="timelines"]', (e) => {
        const $radio = $(e.target);
        let timeline = '';

        if ($radio.prop('checked')) {
          timeline = $radio.val();
        }

        $('input[name="project[timelines]"]').val(timeline);

        return false;
      });

      $(document).on('keypress keyup blur', '.field--custom-budget', (e) => {
        $(e.target).val(
          $(e.target)
            .val()
            .replace(/[^\d].+/, '')
        );
        // only allow integers
        if (e.which < 48 || e.which > 57) {
          e.preventDefault();
        }
      });

      $(document).on('change', '.selection-list--rooms .selection-list__input', (e) => {
        $('.selection-list__label--other').removeClass('selection-list__label--other-selected');
        $('.project-room').addClass('project-room--hide');
        const value = $(e.target).is(':checked') ? $(e.target).val() : '';
        $('.field--project-room').val(value);
      });

      $(document).on('click', '.selection-list__label--other', (e) => {
        // only proceed if the label was clicked, not the text field inside it
        if (!$(e.target).is('.selection-list__label--other')) {
          return false;
        }

        $('.selection-list--rooms').find('input').prop('checked', false);
        $('.selection-list__label--other').addClass('selection-list__label--other-selected');
        $('.project-room').removeClass('project-room--hide');
        $('.field--project-room').val('');
      });

      $(document).on('change', '[name=show_measurements]', (e) => {
        $('.project-dimensions-block').toggle($(e.target).val() === 'now');
      });

      if ($('.textarea--project-form-notes').val()) {
        $('.project-form__textarea-placeholder').hide();
      }
      $(document).on('click touchstart', '.project-form__textarea-placeholder', (e) => {
        $(e.target).hide().siblings('.textarea').focus();
      });

      const isLoggedIn = () => !$('.project-form').find('[data-team-slug]').length;

      let lastPreSignupModalShown = new Date().getTime();
      const showExitIntentModal = () => {
        lastPreSignupModalShown = new Date().getTime();
        if ($('.auth-box:visible').get(0) || $('.modal--questionnaire-exit-popup:visible').get(0)) {
          // skip if modals visible at the moment
          return;
        }
        $('.modal--questionnaire-exit-popup').modal();
      };

      if (!isLoggedIn()) {
        setInterval(() => {
          const timeout = 1000 * 60 * 10; // 10 minutes
          if (lastPreSignupModalShown + timeout > new Date().getTime()) {
            return;
          }
          showExitIntentModal();
        }, 10 * 1000); // each 10 seconds

        $(document).one('mouseleave', showExitIntentModal);
      }

      const showSignupModal = ($form) => {
        const teamSlug = $form.find('[data-team-slug]').data().teamSlug;
        $.get(`/register/${teamSlug}?xhr=1`, (newHTML) => {
          $(newHTML).appendTo('body').modal();
        });
      };

      const submitProject = ($form) => {
        // combine all uploaded items to project
        const itemIds = $('.uploader__thumb')
          .map((i, el) => {
            return $(el).data().id;
          })
          .get()
          .join(',');
        $('.uploader__item-ids').val(itemIds);

        $form.submit();
      };

      $(document).on('click', 'button[data-questionnaire-create-account-button]', () => {
        showSignupModal($('.project-form'));
      });

      $(document).on('click', '.p-button--submit-project, .h-p-button--save-progress', (e) => {
        const $form = $('.project-form');
        const notLoggedIn = !isLoggedIn();

        if ($(e.currentTarget).prop('disabled') === true) {
          return;
        }

        if ($('.uploader__thumb--loading').length) {
          alert('Please wait while all files finish uploading');
          return false;
        }

        if ($(e.currentTarget).hasClass('h-p-button--save-progress')) {
          if (notLoggedIn) {
            showSignupModal($('.project-form'));
          } else {
            $(e.currentTarget).prop('disabled', true);
            submitProject($form);
          }
          return;
        }

        const currentStep = document.location.hash.replace('#', '');

        if (!checkAllRequiredQuestions()) {
          $(e.currentTarget).prop('disabled', false);
          if (currentStep.length === 0) {
            // edit project form
            scrollToProjectFormFirstError();
            return false;
          } else {
            // creatge new project form
            // check if there's any unanswered required question and move there
            // check first question separately
            if ($('.field--project-room').length && !$('.field--project-room').val().length) {
              $('.form-error--project-form-rooms').show();
              document.location.hash = $('.form-error--project-form-rooms').data('step');
              // if first question is answered - check all others
            } else {
              $('.form-error--project-form-required').each(function () {
                if (!checkRequiredQuestion($(this).data('step'))) {
                  document.location.hash = $(this).data('step');
                  return false;
                }
              });
            }
            return false;
          }
        }

        $('.form-error').hide();

        // make sure a project room is specified
        if ($('.field--project-room').length && !$('.field--project-room').val().length) {
          $('.form-error--project-form-rooms').show();
          $('.field--project-room')
            .closest('.project-form-section')
            .find('.form-error--project-form-required')
            .show();
        }

        // make sure budget is non-negative and not out of Rails' integer range
        const MAX_BUDGET = 2000000000;
        const budgetFrom = parseInt($('input[name="project[budget_from]"]').val(), 10);
        const budgetTo = parseInt($('input[name="project[budget_to]"]').val(), 10);
        if (budgetFrom < 0 || budgetTo < 0 || budgetFrom > MAX_BUDGET || budgetTo > MAX_BUDGET) {
          $('.form-error--budget').show();
        }

        if ($('.form-error:visible').length) {
          scrollToProjectFormFirstError();
          $(e.currentTarget).prop('disabled', false);
          return false;
        } else {
          // user is not logged in
          if (notLoggedIn) {
            showSignupModal($form);
          } else {
            submitProject($form);
          }
        }
      });

      $(document).on($.modal.CLOSE, '.auth-box--register', (e) => {
        const submitButton = document.querySelector('.p-button--submit-project');
        if (submitButton) {
          submitButton.disabled = false;
        }
        e.target.remove();
      });

      $(document).on(
        'click',
        '.questionnaire-show-register-modal, .questionnaire-show-login-modal',
        (e) => {
          // remove previous instance modals if they're present
          $('.modal.auth-box--login, .modal.auth-box--register').remove();

          const teamSlug = $('[data-team-slug]').data().teamSlug;
          let url;
          if ($(e.target).is('.questionnaire-show-login-modal')) {
            url = `/login/${teamSlug}?xhr=1`;
          } else {
            url = `/register/${teamSlug}?xhr=1`;
          }
          $.ajax({
            url,
            success(newHTML) {
              $(newHTML).appendTo('body').modal();
            },
          });

          return false;
        }
      );

      $(document).on('click', '.project-form__view-all-uploaded-images', function () {
        $('.project-form__inspiration-image.hide').removeClass('hide');
        $(this).remove();
        return false;
      });

      $(document).on('change', 'input[type="radio"].selection-list__input:checked', (e) => {
        if (
          $(e.target).is(
            '#timelines-custom, #budget-custom, #show_measurements_now, #show_inspiration_now'
          ) ||
          $(e.target).attr('name') === 'project[color_preferences]' ||
          $(e.target).attr('name') === 'project[rent_or_own]' ||
          $(e.target).attr('name') === 'project[kind_of_home]'
        ) {
          return false;
        }
        setTimeout(() => {
          $('.p-button--next-form-section:visible').click();
        }, 300);
      });

      const projectFormStepChange = () => {
        const currentStep = parseInt(document.location.hash.replace('#', ''));
        const stepModifier = $('.project-welcome-message-content').length ? 1 : 0;

        const allSteps = $('.project-form-section').length;
        const progress = (currentStep / allSteps) * 100;
        const sliderWidth = parseInt(
          $('.project-form__progress-bar')[0].style.width.replace('%', '')
        );

        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'Project form', 'Show step', currentStep);
        }

        if (isNaN(currentStep)) {
          const step = parseInt($('input[name="project[last_visited_step]"]').val()) || 1;
          document.location.hash = step;
          $('.project-form-section')
            .eq(step - 1)
            .show();
        }
        $('html, body').animate({ scrollTop: 0 }, 0);

        $('input[name="project[last_visited_step]"]').val(currentStep);
        $('input[name="project[submitted_to_designer]"]').val(currentStep === allSteps);

        if (progress > sliderWidth) {
          $('.project-form-section:visible').addClass('project-form-section--fade-out-next');
          $('.project-form-section')
            .eq(currentStep - 1)
            .show()
            .addClass('project-form-section--fade-in-next');
        } else if (sliderWidth) {
          $('.project-form-section:visible').addClass('project-form-section--fade-out-back');
          $('.project-form-section')
            .eq(currentStep - 1)
            .show()
            .addClass('project-form-section--fade-in-back');
        }

        $('.project-form__progress-bar').width(`${progress}%`);

        $('.project-form-section__number').text(currentStep);

        // remove animation classes wehen animation is finished
        setTimeout(() => {
          $('.project-form-section--fade-out-next, .project-form-section--fade-out-back').hide();
          $('.project-form-section').attr('class', 'project-form-section project-form__element');
        }, 500);

        if (currentStep === allSteps && allSteps >= 1) {
          $('.p-button--next-form-section:not(.p-button--welcome-message)').hide();
          $('.p-button--submit-project').css('display', 'inline-flex');
          $('.h-s-button--back-form-section').css('display', 'inline-flex');
          $('.h-p-button--save-progress').hide();
          $('[data-project-form-hide-sm-after-first-step]').removeClass('hide-sm');
          if (allSteps === 1) {
            $('.h-s-button--back-form-section, .h-p-button--save-progress').hide();
          }
          $('.project-form__submit-container').show();
        } else if (currentStep === 1 + stepModifier) {
          $(
            '.h-s-button--back-form-section, .p-button--submit-project, .h-p-button--save-progress'
          ).hide();
          $('[data-project-form-hide-sm-after-first-step]').removeClass('hide-sm');
          $('.project-form__submit-container').show();
          $('.page-header, .project-form-subheader, .p-button--next-form-section').show();
          if (stepModifier === 1) {
            $('.h-s-button--back-form-section').css('display', 'inline-flex');
          }
        } else if (currentStep === 1 && stepModifier === 1) {
          $('.project-form__submit-container').hide();
        } else {
          $('.page-header, .project-form-subheader, .p-button--submit-project').hide();
          $(
            '.h-s-button--back-form-section, .p-button--next-form-section, .h-p-button--save-progress'
          ).css('display', 'inline-flex');
          $('[data-project-form-hide-sm-after-first-step]').addClass('hide-sm');
        }
      };

      if ($('.project-form--new-project').length) {
        // show step on page load
        $('.project-form-section')
          .eq(parseInt(document.location.hash.replace('#', '')) - 1)
          .show();
        window.onhashchange = projectFormStepChange;

        if (!window.printView) {
          projectFormStepChange();
        }
      }

      $(document).on('click', '.p-button--next-form-section', () => {
        const currentStep = parseInt(document.location.hash.replace('#', ''));

        if (!checkRequiredQuestion(currentStep)) {
          scrollToProjectFormFirstError();
          return false;
        }
        const stepModifier = $('.project-welcome-message-content').length ? 1 : 0;

        if (currentStep === 1 + stepModifier) {
          if ($('.field--project-room').length && !$('.field--project-room').val().length) {
            $('.form-error--project-form-rooms').show();
            $('.field--project-room')
              .closest('.project-form-section')
              .find('.form-error--project-form-required')
              .show();
            scrollToProjectFormFirstError();
            return false;
          }
        }
        if (currentStep === 6 + stepModifier) {
          // make sure budget is non-negative and not out of Rails' integer range
          const MAX_BUDGET = 2000000000;
          const budgetFrom = parseInt($('input[name="project[budget_from]"]').val(), 10);
          const budgetTo = parseInt($('input[name="project[budget_to]"]').val(), 10);
          if (budgetFrom < 0 || budgetTo < 0 || budgetFrom > MAX_BUDGET || budgetTo > MAX_BUDGET) {
            $('.form-error--budget').show();
            scrollToProjectFormFirstError();
            return false;
          }
        }
        if ($('#budget-custom').is(':checked')) {
          const budgetFromCustom = parseInt($('input[name="project[budget_from]"]').val(), 10);
          const budgetToCustom = parseInt($('input[name="project[budget_to]"]').val(), 10);
          if (!(budgetFromCustom > 0) && !(budgetToCustom > 0)) {
            $('#budget-custom')
              .closest('.project-form-section')
              .find('.form-error--project-form-required')
              .show();
            scrollToProjectFormFirstError();
            return false;
          }
        }
        document.location.hash = currentStep + 1;
      });

      $(document).on('click', '.h-s-button--back-form-section', () => {
        const currentStep = parseInt(document.location.hash.replace('#', ''));
        document.location.hash = currentStep - 1;
      });

      $(document).on('change', '[name=show_inspiration]', (e) => {
        $('.project-form-section__inspiration').toggle($(e.target).val() === 'now');
      });

      $(document).on('click', '.t-button--add-inspiration-url-field', (e) => {
        const $inputSelector = $(e.target)
          .parent('.project-form-section__inspiration-urls')
          .find('.project-form-section__inspiration-url-fields:last');
        const id = $inputSelector.attr('id');
        const nextId = ++id.split('_')[2];
        $inputSelector.after(`
          <div id="inspiration_url_${nextId}" class="project-form-section__inspiration-url-fields">
            <input type="text" name="project[inspiration_urls][]" value="" class="field field--inspiration-url" placeholder="Add inspiration URL">
            <button name="button" type="button" class="delete-link project-form-section__remove-inspiration-url"></button>
          </div>
        `);
        $(`#inspiration_url_${nextId} input`).focus();
      });

      $(document).on('click', '.project-form-section__remove-inspiration-url', (e) => {
        $(e.target).parent('.project-form-section__inspiration-url-fields').remove();
        $('.project-form-section__inspiration-urls')
          .find('.project-form-section__inspiration-url-fields:last input')
          .focus();
      });

      $(document).on('change', 'input[type=checkbox], input[type=radio]', (e) => {
        const $container = $(e.target).closest('.project-form-section');
        const $requiredErrorMessage = $container.find('.form-error--project-form-required');
        if ($requiredErrorMessage.length > 0) {
          $requiredErrorMessage.hide();
        }
      });

      $(document).on('keyup paste change', '.field, .textarea', (e) => {
        const $container = $(e.target).closest('.project-form-section');
        const $requiredErrorMessage = $container.find('.form-error--project-form-required');
        if ($requiredErrorMessage.length > 0) {
          $requiredErrorMessage.hide();
        }
      });
    }
  });

  // check if window is opened in print mode
  if (window.printView) {
    // update page style to make it printable
    $('.project-form-section').show();
    const sectionNumbers = document.querySelectorAll('.project-form-section');
    sectionNumbers.forEach((step, index) => {
      $(step)
        .find('.project-form-section__number')
        .text(index + 1);
    });

    // add hook to close window after it's printed
    window.onafterprint = () => {
      $(function () {
        window.close();
      });
    };

    // print the page
    window.print();
  }
});
